export type SolutionsCardsProps = {
  text: string;
};

export const solutionsCardsTexts = ['u1', 'm1', 'c1', 'CI/CD'];
